import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { DeviceData } from './types'
import Cookies from 'js-cookie'

// initialize an empty api service that we'll inject endpoints into later as needed
const pythonApi = createApi({
  reducerPath: 'pythonApi',
  keepUnusedDataFor: 300,
  tagTypes: [
    'List',
    'ReportData',
    'ListAlarms',
    'ListGroups',
    'ListDevices',
    'ListDevicesAutomation',
    'ListGroupsAutomation',
    'Cost',
    'ListTenantUsers',
    'DeviceGroups',
    'ListDeviceConfig',
    'DeviceAutoDiscovery'
  ],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = window.localStorage.getItem('aiot_t')
      const methodiaAiotCookie = Cookies.get('aiot_methodia_user')
      if (token) {
        headers.set('Authorization', `Token ${token}`)
      }
      if (methodiaAiotCookie) {
        headers.set('x-aiot-methodia-user', methodiaAiotCookie)
      }

      return headers
    },
  }),
  endpoints: (builder) => ({
    getDeviceData: builder.query<DeviceData.Response, DeviceData.Request>({
      query: ({ from, to, location, device }) => {
        const queryParams = new URLSearchParams()
        queryParams.append('from_date', from)
        queryParams.append('to_date', to)

        if (location) {
          queryParams.append('location', location)
        }

        if (device) {
          queryParams.append('device', device)
        }
        return {
          url: `/data/total/?${queryParams.toString()}`,
          method: 'GET',
        }
      },
    }),
  }),
})

export default pythonApi
